var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent } from 'gp-admin-abstract';
var InputComponent = /** @class */ (function (_super) {
    __extends(InputComponent, _super);
    function InputComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.title = '';
        _this.type = '';
        _this.inputName = '';
        _this.value = '';
        _this.placeholder = '';
        _this.disabled = false;
        _this.state = '';
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    InputComponent.prototype.change = function () {
        this.propagateChange(this.value);
    };
    InputComponent.prototype.writeValue = function (value) {
        this.value = value;
    };
    InputComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    InputComponent.prototype.registerOnTouched = function (fn) {
    };
    InputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-input',
                    template: "\n<div\n  class=\"input\"\n  [ngClass]=\"[\n    !!state ? 'input--'+state : '',\n    !!disabled ? 'input--disabled' : '',\n    value !== '' ? 'input--filled' : ''\n  ]\"\n>\n  <!-- success / error / filled -->\n\n  <div class=\"flex flex--content-between\">\n    <div class=\"input__title\">{{ title }}</div>\n    <div class=\"input__error\">{{ errorText }}</div>\n  </div>\n\n  <input\n    [type]=\"type\"\n    class=\"input__area\"\n    [(ngModel)]=\"value\"\n    (ngModelChange)=\"change()\"\n    [placeholder]=\"placeholder\"\n    [disabled]=\"disabled\"\n  >\n\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-input\"\n */\n.gp-input {\n  min-width: 18rem; }\n  .gp-input--success input.gp-input__area {\n    border-color: #00afec; }\n  .gp-input--success .gp-input__title {\n    color: #00afec; }\n  .gp-input--error input.gp-input__area {\n    border-color: #f35252; }\n  .gp-input--error .gp-input__title {\n    color: #f35252; }\n  .gp-input--error .gp-input__error {\n    display: block; }\n  .gp-input--disabled {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n    .gp-input--disabled input.gp-input__area {\n      cursor: not-allowed;\n      color: #b5b5b5;\n      border-color: #dbdbdb;\n      background-color: #f8f8f8; }\n  .gp-input__title {\n    font: 400 1.2rem/1.4rem \"Roboto\", sans-serif;\n    margin-bottom: 0.5rem;\n    color: #b5b5b5;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n  .gp-input__error {\n    font: 400 1.2rem/1.4rem \"Roboto\", sans-serif;\n    display: none;\n    color: #f35252; }\n  .gp-input__area {\n    font: 1.3rem/1.5rem \"Roboto\", sans-serif;\n    width: 100%;\n    padding: 1rem 1.5rem;\n    color: #212121;\n    border: 0.1rem solid #dbdbdb;\n    border-radius: 0.02rem;\n    background-color: var(--color-white); }\n    .gp-input__area[type=\"password\"] {\n      letter-spacing: 0.5rem;\n      font-weight: 900; }\n  .gp-input input::-webkit-input-placeholder,\n  .gp-input input:-ms-input-placeholder,\n  .gp-input input::placeholder {\n    color: #b5b5b5;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return InputComponent; }),
                            multi: true
                        }
                    ],
                },] },
    ];
    /** @nocollapse */
    InputComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    InputComponent.propDecorators = {
        'title': [{ type: Input },],
        'type': [{ type: Input },],
        'inputName': [{ type: Input },],
        'value': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'disabled': [{ type: Input },],
        'state': [{ type: Input },],
        'errorText': [{ type: Input },],
    };
    return InputComponent;
}(AbstractComponent));
export { InputComponent };
//# sourceMappingURL=input.component.js.map